<fc-general-modal [baseId]="baseId" [form]="form" [fcModalItemContext]="fcModalItemContext" (saveForm)="save()"
  (cancelForm)="onCancel()">
  <div [formGroup]="form">
    <div class="flex-row-generic">
      <!-- External Id Control -->
      <div class="form-group flex-item-two-columns">
        <label for="{{ baseId }}-id" translate>ID</label>
        <input id="{{ baseId }}-id" class="form-control"
          [ngClass]="{ error: showErrors(externalIdControl, isSubmitted),'required': isRequired(externalIdControl) }" type="text"
          [maxlength]="fcListValidation.validations.ExternalID.MaxLength" formControlName="externalId" />
        <div *ngIf="showErrors(externalIdControl, isSubmitted)" id="{{ baseId }}-warning-text-id"
          class="incorrect-input" translate>
          {{ externalIdControl.errors | fcListValidation : 'ID' }}
        </div>
      </div>
      <!-- External Id Control -->

      <!-- Name Control -->
      <div class="form-group flex-item-two-columns">
        <label for="{{ baseId }}-name" translate>Name</label>
        <div class="dropdown">
          <input
            id="{{ baseId }}-name"
            class="form-control"
            [ngClass]="{ error: showErrors(nameControl, isSubmitted), 'required': isRequired(nameControl) }"
            type="text"
            [maxlength]="fcListValidation.validations.Name.MaxLength"
            formControlName="name" />
        </div>
        <div *ngIf="showErrors(nameControl, isSubmitted)" class="incorrect-input" id="{{ baseId }}-warning-text-name"
          translate>
          {{ nameControl.errors | fcListValidation : 'Name' }}
        </div>
      </div>
      <!-- Name Control -->
    </div>

    <div class="flex-row-generic">
      <!-- Clinic Name Control -->
      <div class="form-group flex-item-two-columns">
        <label for="{{ baseId }}-clinic-name" translate>Clinic Name</label>
        <input
          id="{{ baseId }}-clinic-name"
          class="form-control"
          [ngClass]="{ error: showErrors(clinicNameControl, isSubmitted), 'required': isRequired(clinicNameControl) }"
          type="text"
          [maxlength]="fcListValidation.validations.ClinicName.MaxLength"
          formControlName="clinicName" />
        <div *ngIf="showErrors(clinicNameControl, isSubmitted)" id="{{ baseId }}-warning-text-id"
          class="incorrect-input" translate>
          {{ clinicNameControl.errors | fcListValidation : 'Clinic Name' }}
        </div>
      </div>
      <!-- Clinic Name Control -->

      <!-- Name Control -->
      <div class="form-group flex-item-two-columns">
        <label for="{{ baseId }}-clinic-id" translate>Clinic ID</label>
        <div class="dropdown">
          <input id="{{ baseId }}-clinic-id"
            class="form-control"
            [ngClass]="{ error: showErrors(clinicIDControl, isSubmitted), 'required': isRequired(clinicIDControl) }"
            type="text"
            [maxlength]="fcListValidation.validations.ClinicID.MaxLength"
            formControlName="clinicID" />
        </div>
        <div *ngIf="showErrors(clinicIDControl, isSubmitted)" class="incorrect-input"
          id="{{ baseId }}-warning-text-name" translate>
          {{ clinicIDControl.errors | fcListValidation : 'Clinic ID' }}
        </div>
      </div>
      <!-- Name Control -->
    </div>

    <!-- Notes Control -->
    <div class="form-group full-control">
      <label for="{{ baseId }}-notes" translate>Notes</label>
      <textarea class="form-control" [ngClass]="{ error: showErrors(notesControl, isSubmitted), 'required': isRequired(notesControl) }"
        id="{{ baseId }}-notes" [maxlength]="fcListValidation.validations.Notes.MaxLength" formControlName="notes"
        rows="3">
        </textarea>
      <div *ngIf="showErrors(notesControl, isSubmitted)" id="{{ baseId }}-warning-text-notes" class="incorrect-input"
        translate>
        {{ notesControl.errors | fcListValidation : 'Notes' }}
      </div>
    </div>
    <!-- Notes Control -->
    <br>
      <mat-tab-group animationDuration="0ms" mat-align-tabs="start" class="tabs-default half-modal-tabs" [disableRipple]="true">
        <mat-tab>
          <ng-template mat-tab-label>
            <span class="tab-label" translate>Providers</span>
            <mat-badge *ngIf="getFormValidationErrors(providersGroup) as errorCount" [matBadge]="errorCount" matBadgeColor="warn"
            matBadgeSize="small" matBadgePosition="after"></mat-badge>
            </ng-template>
            <fc-pharmacy-clearinghouse-providers-tab
            [baseId]="baseId" [form]="providersGroup" [listItem]="listItem" [itemContext]="fcModalItemContext"
            ></fc-pharmacy-clearinghouse-providers-tab>
          </mat-tab>
          <mat-tab *ngIf="!isFax">
            <ng-template mat-tab-label>
              <span class="tab-label" translate translate>Interface Details</span>
              <mat-badge *ngIf="getFormValidationErrors(interfaceDetailsGroup) as errorCount" [matBadge]="errorCount" matBadgeColor="warn"
            matBadgeSize="small" matBadgePosition="after"></mat-badge>
            </ng-template>
            <fc-pharmacy-clearinghouse-interface-details-tab
          [baseId]="baseId" [form]="interfaceDetailsGroup" [listItem]="listItem" [itemContext]="fcModalItemContext">
        </fc-pharmacy-clearinghouse-interface-details-tab>
      </mat-tab>
      <mat-tab *ngIf="!isFax">
        <ng-template mat-tab-label>
          <span class="tab-label" translate>Manage Pharmacy</span>
          <mat-badge *ngIf="getFormValidationErrors(managePharmacyGroup) as errorCount" [matBadge]="errorCount" matBadgeColor="warn"
          matBadgeSize="small" matBadgePosition="after"></mat-badge>
        </ng-template>
        <fc-pharmacy-clearinghouse-manage-pharmacy-tab
        [baseId]="baseId" [form]="managePharmacyGroup" [listItem]="listItem" [itemContext]="fcModalItemContext">
      </fc-pharmacy-clearinghouse-manage-pharmacy-tab>
    </mat-tab>
  </mat-tab-group>

    <!-- Inactive and User Defined checkboxes -->
    <div class="checkbox-group">
      <mat-checkbox [ngClass] ="{ notShown: isFax }" id="{{ baseId }}-inactive-checkbox" formControlName="inactive" translate> Inactive </mat-checkbox>
      <mat-checkbox id="{{ baseId }}-user-defined-checkbox" formControlName="userDefined" translate> User Defined
      </mat-checkbox>
    </div>
    <!-- Inactive and User Defined checkboxes -->
  </div>
</fc-general-modal>